import { Input } from '@flixbus/honeycomb-react';

import { Asterisk } from '../../Asterisk';
import { useVoucherFormContext } from '../../Context';

import useOnMount from '../../../../hooks/useInit';

const VoucherFormPercentageMarketing = () => {
  const DEFAULT_DISCOUNT_TYPE = {
    type: 'percentage_marketing',
    percentage: 0.3,
  };

  const {
    formState: {
      payload: { discountType },
    },
    handlePayloadChange,
  } = useVoucherFormContext();

  useOnMount(() => handlePayloadChange({ value: DEFAULT_DISCOUNT_TYPE, prop: 'discountType' }));

  return (
    <div>
      <Input
        name='percentage-marketing'
        id='percentage-marketing'
        label={
          <>
            Percentage <Asterisk />
          </>
        }
        type='number'
        step={10}
        max={100}
        required
        value={(discountType.percentage && discountType.percentage * 100) || 0}
        onChange={e => {
          handlePayloadChange({
            value: {
              type: 'percentage_marketing',
              percentage: parseFloat(e.target.value) / 100,
            },
            prop: 'discountType',
          });
        }}
      />
    </div>
  );
};

export default VoucherFormPercentageMarketing;
